import type { Message } from '../types';

/** True when the message was sent as or addressed to the given alias username (local part). */
export function messageMatchesAlias(msg: Message, aliasUsername: string): boolean {
  const aliasLower = aliasUsername.trim().toLowerCase();
  if (!aliasLower) return true;

  const fromLocal = (msg.fromAddress || msg.fromName || '').split('@')[0]?.trim().toLowerCase() ?? '';
  const fromName = (msg.fromName || '').trim().toLowerCase();
  if (fromLocal === aliasLower || fromName === aliasLower) return true;

  const recipientLists = [msg.toRecipients, msg.ccRecipients, msg.bccRecipients];
  return recipientLists.some(list =>
    (list ?? []).some(addr => addr.split('@')[0]?.trim().toLowerCase() === aliasLower)
  );
}
